module.exports = __webpack_public_path__ + "img/line-1.2438b9a2.png";